import { useEffect, useReducer, useRef, useState } from 'react'
import Form from './form'
import Rules from './rules'
import { IconName, GiOysterPearl,HiArrowsRightLeft } from 'react-icons/gi'
import king from '../King Mermaid.png'
import coverpearl from '../cover_shell.png'
import crown from '../crown.png'
import { Slide, Fade } from 'react-awesome-reveal'
import pearl from '../s_pearl.png'



const reducer = (state, action) => {
    switch (action.type) {
      case 'removeStar1': return {...state, button1:false };
      case 'removeStar2': return {...state, button2:false }; 
      case 'removeStar3': return {...state, button3:false };
      case 'removeStar4': return {...state, button4:false };
      case 'removeStar5': return {...state, button5:false };
      case 'removeStar6': return {...state, button6:false };
      case 'removeStar7': return {...state, button7:false };
      case 'removeStar8': return {...state, button8:false };
      default:
    }
  };

function Board(props) {
  const players = {
    player_1: '',
    player_2: '',
  }

  let pl1 = 'player1 wins'
  let pl2 = 'player2 wins'

  let star = [
   <img src={pearl} alt='pearl' style = {{width:'1em'}}/>,
   <img src={pearl} alt='pearl' style = {{width:'1em'}}/>,
   <img src={pearl} alt='pearl' style = {{width:'1em'}}/>,
   <img src={pearl} alt='pearl' style = {{width:'1em'}}/>,
   <img src={pearl} alt='pearl' style = {{width:'1em'}}/>,
   <img src={pearl} alt='pearl' style = {{width:'1em'}}/>,
   <img src={pearl} alt='pearl' style = {{width:'1em'}}/>,
   <img src={pearl} alt='pearl' style = {{width:'1em'}}/>,
   <img src={pearl} alt='pearl' style = {{width:'1em'}}/>,
   <img src={pearl} alt='pearl' style = {{width:'1em'}}/>,
   <img src={pearl} alt='pearl' style = {{width:'1em'}}/>,
   <img src={pearl} alt='pearl' style = {{width:'1em'}}/>,
   <img src={pearl} alt='pearl' style = {{width:'1em'}}/>,
   <img src={pearl} alt='pearl' style = {{width:'1em'}}/>,
   <img src={pearl} alt='pearl' style = {{width:'1em'}}/>,
   <img src={pearl} alt='pearl' style = {{width:'1em'}}/>,
   <img src={pearl} alt='pearl' style = {{width:'1em'}}/>,
   <img src={pearl} alt='pearl' style = {{width:'1em'}}/>,
   <img src={pearl} alt='pearl' style = {{width:'1em'}}/>,
   <img src={pearl} alt='pearl' style = {{width:'1em'}}/>,
  ]

const imagesForPearl = <img src={pearl} alt='pearl' style = {{width:'1em'}}/>
 
//useReduce hook*********************
const initialState ={button1:true,button2:true,button3:true,button4:true,button5:true,button6:true,button7:true,button8:true}
const [state, dispatch] = useReducer(reducer, initialState);




//useState hook**********************************
  const [stars, setStars] = useState(star)
  const [count, setCount] = useState(20)
  const [player1, setPlayer] = useState(true)
  const [start, setStart] = useState(true)
  const [playBoard, setPlayBoard] = useState(false)
  const [result, setResult] = useState(false)

  //useRef hook**********************************

// // const buttonRef = useRef();

// // const hideMe = () => {
// //    // buttonRef.current.innerHTML = 'Clicked!'
// //    console.log(buttonRef.current)
// // }
  

  useEffect(() => {
    
    let note = stars.slice(0, count)

    setStars(note);
   if(count <= 1 && player1 === true){ setResult(true); } ;
   if(count <= 1 && player1 === false){  setResult(true); } ;
    
  }, [count])

  const [newPlayers, setPlayers] = useState(players)

  function addPlayers(player) {
    setPlayers(player)
    setPlayBoard(true)
  }

  function removeStar1() {
    
    setCount((c) => c - 1)
    setPlayer(false)
    setStart(false)
    dispatch({ type: 'removeStar1'})
  }

  function removeStar2() {
    setCount((c) => c - 2)
    setStart(false)
    setPlayer(false)
    dispatch({ type: 'removeStar2'})
  }

  function removeStar3(e) {
    e.preventDefault()
    setCount((c) => {
      return c - 3
    })
    setStart(false)
    setPlayer(false)
    dispatch({ type: 'removeStar3'})
  }
  function removeStar7(e) {
    e.preventDefault()
    setCount((c) => {
      return c - 4
    })
    setStart(false)
    setPlayer(false)
    dispatch({ type: 'removeStar4'})
  }

  function removeStar4() {
    setCount((c) => c - 1)
    setPlayer(true)
    setStart(false)
    dispatch({ type: 'removeStar5'})
  }

  function removeStar5() {
    setCount((c) => c - 2)
    setStart(false)
    setPlayer(true)
    dispatch({ type: 'removeStar6'})
  }

  function removeStar6(e) {
    e.preventDefault()
    setCount((c) => {
      return c - 3
    })
    setStart(false)
    setPlayer(true)
    dispatch({ type: 'removeStar7'})
  }
  
  
  function removeStar8(e) {
    e.preventDefault()
    setCount((c) => {
      return c - 4
    })
    setStart(false)
    setPlayer(true)
    dispatch({ type: 'removeStar8'})
    
  }
 

  function startBy() {
    setPlayer(false)
    setStart(false)
  }

  return (
    <>
      {playBoard === false ? (
        <>
          <div className="d-flex justify-content-center flex-column-reverse flex-md-row p-2  ">
            <div className="  m-5 ">
              <Rules /> , <Form addPlayers={addPlayers} />
            </div>
            <div>
            <img
              className="d-inline-flex img-fluid "
              src={king}
              alt="King"
            />
            </div>
          </div>
        </>
      ) : (
        <>
          {result===false?<p className="glow">{stars}</p>:""}
          
          <p>{count <= 1 && player1 === true ?<><Fade> <img
                    className="d-inline-flex pearlcover img-fluid crown"
                    src={ crown }
                    alt="crown"
                  /> <p className="fst-italic fw-bold fs-4 text-warning ">{newPlayers.player_1 || 'Player_1'} wins</p><p className="fst-italic fw-bold fs-3 text-warning">Thanks for playing Pearl Play</p> <button className="btn btn-outline-warning fw-bold btn-lg" onClick={() => window.location.reload(false)}>Play Again!</button></Fade></> : ''}</p>
          <p>{count <= 1 && player1 === false ? <><Fade> <img
                    className="d-inline-flex pearlcover img-fluid crown"
                    src={ crown }
                    alt="crown"
                  /> <p className="fst-italic fw-bold fs-4 text-warning">{newPlayers.player_2 || 'Player_2'} wins</p><p className="fst-italic fw-bold fs-3 text-warning">Thanks for playing Pearl Play</p> <button className="btn btn-outline-warning fw-bold btn-lg" onClick={() => window.location.reload(false)}>Play Again!</button></Fade></> : ''}</p>
          <div className="d-flex flex-column align-items-center justify-content-evenly flex-md-row justify-content-evenly align-items-start ">
            {player1 && result === false ? (
              <div className=" pearl d-flex flex-column align-items-center p-5 m-4 ">
                <Fade>
                <h4 className="fst-italic fw-bold fs-4 text-warning ">
                    {newPlayers.player_1 || 'Player_1'}'s turn
                  </h4>


                  <div className=" d-flex flex-column align-items-center justify-content-center p-5 m-4">
                 { state.button1 ?<button 
                    className="btn bg-warning-subtle border border-warning p-2 m-1 rounded-circle btn-lg d-flex flex-row"
                    onClick={removeStar1}
                  >
                   {imagesForPearl}
                  </button>:<button 
                    className="btn bg-dark border border-warning p-2 m-1 rounded-circle btn-lg d-flex flex-row"
                  >
                   {imagesForPearl}
                  </button>}
                  { state.button2 ?<button
                    className="btn bg-warning-subtle border border-warning p-2 m-1 rounded-circle btn-lg d-flex flex-row"
                    onClick={removeStar2}
                  >
                   {imagesForPearl}{imagesForPearl}
                  </button>:<button 
                    className="btn bg-dark border border-warning p-2 m-1 rounded-circle btn-lg d-flex flex-row"
                  >
                   {imagesForPearl} {imagesForPearl}
                  </button>}
                  { state.button3 ?<button
                    className="btn bg-warning-subtle border border-warning p-2 m-1 rounded-circle btn-lg d-flex flex-row"
                    onClick={removeStar3}
                  >
                  {imagesForPearl}{imagesForPearl}{imagesForPearl}
                  </button>:<button 
                    className="btn bg-dark border border-warning p-2 m-1 rounded-circle btn-lg d-flex flex-row"
                  >
                   {imagesForPearl} {imagesForPearl} {imagesForPearl}
                  </button>}
                  { state.button4 ?<button
                    className="btn bg-warning-subtle border border-warning p-2 m-1 rounded-circle btn-lg d-flex flex-row"
                    onClick={removeStar7}
                  >
                   {imagesForPearl}{imagesForPearl}{imagesForPearl}{imagesForPearl}
                  </button>:<button 
                    className="btn bg-dark border border-warning p-2 m-1 rounded-circle btn-lg d-flex flex-row"
                  >
                   {imagesForPearl} {imagesForPearl} {imagesForPearl} {imagesForPearl}
                  </button>}
                  </div>
                  
                </Fade>
              </div>
            ) : (
              <div className='p-5 m-4 d-flex align-self-center'>
                <Fade cascade>
                  <img
                    className="d-inline-flex pearlcover img-fluid opacity-50"
                    src={coverpearl}
                    alt="coverpearl"
                  />
                </Fade>
              </div>
            )}
            
              {start ? (
                <div className='p-5 m-4 d-flex align-self-center'>
                <button
                className="btn btn-outline-warning fw-bold btn-md rounded-pill"
                  onClick={startBy}
                >
                  Like to start by Player2
                </button>
                </div>
              ) : (
                '')}
            
            {player1 === false && result === false? (
              <div className="pearl d-flex flex-column align-items-center p-5 m-4">
                <Fade>

                <h4 className="fst-italic fw-bold fs-4 text-warning ">
                    {newPlayers.player_2 || 'Player_2'}'s turn
                  </h4>

                 <div className=" d-flex flex-column align-items-center p-5 m-4"> 
                  { state.button5 ? <button
                    className="btn p-2 m-1 rounded-circle btn-lg bg-warning-subtle border border-success d-flex flex-row"
                    onClick={removeStar4}
                  >
                   {imagesForPearl}
                  </button>:<button 
                    className="btn bg-dark border border-warning p-2 m-1 rounded-circle btn-lg d-flex flex-row"
                  >
                   {imagesForPearl}
                  </button>}
                 { state.button6 ? <button
                    className="btn p-2 m-1 rounded-circle btn-lg bg-warning-subtle border border-success d-flex flex-row"
                    onClick={removeStar5}
                  >
                  {imagesForPearl}{imagesForPearl}
                  </button>:<button 
                    className="btn bg-dark border border-warning p-2 m-1 rounded-circle btn-lg d-flex flex-row"
                  >
                   {imagesForPearl} {imagesForPearl}
                  </button>}
                  { state.button7 ?<button
                    className="btn p-2 m-1 rounded-circle btn-lg bg-warning-subtle border border-success d-flex flex-row "
                    onClick={removeStar6}
                  >
                  {imagesForPearl}{imagesForPearl}{imagesForPearl}
                  </button>:<button 
                    className="btn bg-dark border border-warning p-2 m-1 rounded-circle btn-lg d-flex flex-row"
                  >
                   {imagesForPearl} {imagesForPearl} {imagesForPearl}
                  </button>}
                  { state.button8 ?<button className='btn p-2 m-1 rounded-circle btn-lg bg-warning-subtle border border-success d-flex flex-row ' onClick={removeStar8}>
                  {imagesForPearl}{imagesForPearl}{imagesForPearl}{imagesForPearl}
                  </button>:<button 
                    className="btn bg-dark border border-warning p-2 m-1 rounded-circle btn-lg d-flex flex-row"
                  >
                   {imagesForPearl} {imagesForPearl} {imagesForPearl} {imagesForPearl}
                  </button>}
                  </div>
                 
                  
                </Fade>
              </div>
            ) : (result === false?<div className="p-5 m-4 d-flex align-self-center">
            <Fade cascade>
              <img
                className="d-inline-flex pearlcover img-fluid opacity-50 "
                src={coverpearl}
                alt="coverpearl"
              />
            </Fade>
          </div>:''
             
            )}
          </div>{' '}
        </>
      )}
    </>
  )
}
export default Board
